/**
 * @generated SignedSource<<f665d94a7a4b26147b4c17383c29b8a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportPageQuery$variables = {
  reportId: string;
  resolutionSection?: string | null;
  anomalies?: ReadonlyArray<string | null> | null;
};
export type ReportPageQuery$data = {
  readonly reportById: {
    readonly reportWorkflowWorkspaces: {
      readonly nodes: ReadonlyArray<{
        readonly reportWorkflowWorkspaceSteps: {
          readonly nodes: ReadonlyArray<{
            readonly id: string;
            readonly key: string;
            readonly " $fragmentSpreads": FragmentRefs<"StepHeader_reportWorkflowWorkspaceStep" | "ReportStep_reportWorkflowWorkspaceStep">;
          }>;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceHeader_report" | "ReportContainer_report">;
  } | null;
};
export type ReportPageQuery = {
  variables: ReportPageQuery$variables;
  response: ReportPageQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "anomalies"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportId"
},
v2 = {
  "defaultValue": "forReview",
  "kind": "LocalArgument",
  "name": "resolutionSection"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reportId"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "WORKSPACE_ORDER_ASC"
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "STEP_ORDER_ASC"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepOrder",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workspaceOrder",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "anomalies",
        "variableName": "anomalies"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "resolutionSection"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceHeader_report"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportContainer_report"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ReportWorkflowWorkspacesConnection",
            "kind": "LinkedField",
            "name": "reportWorkflowWorkspaces",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportWorkflowWorkspace",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                    "kind": "LinkedField",
                    "name": "reportWorkflowWorkspaceSteps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportWorkflowWorkspaceStep",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "StepHeader_reportWorkflowWorkspaceStep"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ReportStep_reportWorkflowWorkspaceStep"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "reportWorkflowWorkspaces(orderBy:\"WORKSPACE_ORDER_ASC\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "config",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reviewStatus",
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ReportWorkflowWorkspacesConnection",
            "kind": "LinkedField",
            "name": "reportWorkflowWorkspaces",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportWorkflowWorkspace",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                    "kind": "LinkedField",
                    "name": "reportWorkflowWorkspaceSteps",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReportWorkflowWorkspaceStep",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sections",
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v7/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReportWorkflowWorkspace",
                            "kind": "LinkedField",
                            "name": "reportWorkflowWorkspace",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": (v5/*: any*/),
                                "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                                "kind": "LinkedField",
                                "name": "reportWorkflowWorkspaceSteps",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReportWorkflowWorkspaceStep",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Report",
                                "kind": "LinkedField",
                                "name": "report",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v4/*: any*/),
                                    "concreteType": "ReportWorkflowWorkspacesConnection",
                                    "kind": "LinkedField",
                                    "name": "reportWorkflowWorkspaces",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReportWorkflowWorkspace",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v11/*: any*/),
                                          {
                                            "alias": null,
                                            "args": (v5/*: any*/),
                                            "concreteType": "ReportWorkflowWorkspaceStepsConnection",
                                            "kind": "LinkedField",
                                            "name": "reportWorkflowWorkspaceSteps",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ReportWorkflowWorkspaceStep",
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                  (v6/*: any*/),
                                                  (v9/*: any*/),
                                                  (v10/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "reportWorkflowWorkspaces(orderBy:\"WORKSPACE_ORDER_ASC\")"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "reportWorkflowWorkspaceSteps(orderBy:\"STEP_ORDER_ASC\")"
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Report",
                    "kind": "LinkedField",
                    "name": "report",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "reportWorkflowWorkspaces(orderBy:\"WORKSPACE_ORDER_ASC\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportUserFilesConnection",
            "kind": "LinkedField",
            "name": "reportUserFiles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportUserFile",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserFile",
                    "kind": "LinkedField",
                    "name": "userFile",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meta",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "pendingResolutions",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "updateStatus": "pending"
                }
              }
            ],
            "concreteType": "ReportResolutionsConnection",
            "kind": "LinkedField",
            "name": "reportResolutions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": "reportResolutions(condition:{\"updateStatus\":\"pending\"})"
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errors",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkflowTemplate",
            "kind": "LinkedField",
            "name": "workflowTemplate",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportIntegrationsConnection",
            "kind": "LinkedField",
            "name": "reportIntegrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportIntegration",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Integration",
                    "kind": "LinkedField",
                    "name": "integration",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AnomalyCount",
            "kind": "LinkedField",
            "name": "anomalyCounts",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "ReportResolutionsConnection",
            "kind": "LinkedField",
            "name": "filteredReportResolutions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportResolutionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportResolution",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "anomalyTypes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updateStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "responseData",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resolutionKind",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v15/*: any*/),
            "filters": [
              "input"
            ],
            "handle": "connection",
            "key": "ReportResolutionTable_filteredReportResolutions",
            "kind": "LinkedHandle",
            "name": "filteredReportResolutions"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolutionProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4bbf9e964262bcb58598b67c496324a8",
    "id": null,
    "metadata": {},
    "name": "ReportPageQuery",
    "operationKind": "query",
    "text": "query ReportPageQuery(\n  $reportId: ID!\n  $resolutionSection: String = \"forReview\"\n  $anomalies: [String] = null\n) {\n  reportById(id: $reportId) {\n    ...WorkspaceHeader_report\n    ...ReportContainer_report\n    reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n      nodes {\n        reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n          nodes {\n            id\n            key\n            ...StepHeader_reportWorkflowWorkspaceStep\n            ...ReportStep_reportWorkflowWorkspaceStep\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ReportContainer_report on Report {\n  id\n  ...ReportViewContainer_report\n  ...ReportContent_report\n  ...ReportResolution_report\n  ...ReportResolutionTable_report\n}\n\nfragment ReportContent_report on Report {\n  rowId\n  name\n}\n\nfragment ReportResolutionTable_report on Report {\n  filteredReportResolutions(input: {anomalies: $anomalies, status: $resolutionSection}, first: 100) {\n    edges {\n      node {\n        id\n        anomalyTypes\n        currentValue\n        status\n        updateStatus\n        responseData\n        resolutionKind\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  resolutionProgress\n  reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n    nodes {\n      reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n        nodes {\n          id\n          status\n        }\n      }\n      id\n    }\n  }\n  id\n}\n\nfragment ReportResolution_report on Report {\n  id\n  reviewStatus\n  anomalyCounts {\n    type\n    count\n  }\n}\n\nfragment ReportStatusDetails_report on Report {\n  id\n  errors\n  periodStart\n  periodEnd\n  sourceKind\n  workflowTemplate {\n    id\n  }\n  reportUserFiles {\n    nodes {\n      type\n      userFile {\n        id\n        name\n        meta\n      }\n      id\n    }\n  }\n  reportIntegrations {\n    nodes {\n      integration {\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ReportStep_reportWorkflowWorkspaceStep on ReportWorkflowWorkspaceStep {\n  key\n}\n\nfragment ReportViewContainer_report on Report {\n  id\n  rowId\n  createdAt\n  periodStart\n  periodEnd\n  config\n  status\n  reviewStatus\n  sourceKind\n  ...WorkflowDashboard_report\n  ...ReportStatusDetails_report\n  reportIntegrations {\n    nodes {\n      integration {\n        id\n        kind\n      }\n      id\n    }\n  }\n  reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n    nodes {\n      key\n      reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n        nodes {\n          id\n          key\n          sections\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment StepHeader_reportWorkflowWorkspaceStep on ReportWorkflowWorkspaceStep {\n  id\n  stepOrder\n  status\n  key\n  reportWorkflowWorkspace {\n    id\n    workspaceOrder\n    reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n      nodes {\n        id\n        key\n        name\n        stepOrder\n      }\n    }\n    report {\n      id\n      reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n        nodes {\n          id\n          workspaceOrder\n          reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n            nodes {\n              id\n              status\n              stepOrder\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment WorkflowDashboard_report on Report {\n  reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n    nodes {\n      name\n      key\n      workspaceOrder\n      ...WorkflowWorkspace_reportWorkflowWorkspace\n      id\n    }\n  }\n}\n\nfragment WorkflowWorkspace_reportWorkflowWorkspace on ReportWorkflowWorkspace {\n  key\n  name\n  reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n    nodes {\n      name\n      status\n      ...WorkspaceStep_reportWorkflowWorkspaceStep\n      id\n    }\n  }\n  report {\n    rowId\n    id\n  }\n}\n\nfragment WorkspaceHeader_report on Report {\n  id\n  name\n  config\n  reviewStatus\n  status\n  reportWorkflowWorkspaces(orderBy: WORKSPACE_ORDER_ASC) {\n    nodes {\n      id\n      name\n      key\n      reportWorkflowWorkspaceSteps(orderBy: STEP_ORDER_ASC) {\n        nodes {\n          id\n          status\n          sections\n        }\n      }\n    }\n  }\n  reportUserFiles {\n    nodes {\n      type\n      userFile {\n        id\n        rowId\n        kind\n        name\n        key\n      }\n      id\n    }\n  }\n  pendingResolutions: reportResolutions(condition: {updateStatus: \"pending\"}) {\n    totalCount\n  }\n}\n\nfragment WorkspaceStep_reportWorkflowWorkspaceStep on ReportWorkflowWorkspaceStep {\n  id\n  key\n  name\n  stepOrder\n  sections\n  status\n  description\n}\n"
  }
};
})();

(node as any).hash = "ff866d5e570c5648351762b747ebc563";

export default node;
